import { AssessmentData, SectionData } from '.'

function isAssessmentAutoCollapsing(section: SectionData, assessment: AssessmentData) {
  return assessment.isAutoCollapse ?? section.isAutoCollapse ?? false
}

export default isAssessmentAutoCollapsing
